<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/statistiques" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour aux statistiques</a>
      <span class="crumb-current">Mes Achats</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Historique</p>
        <h1>Achats personnels</h1>
        <p class="lead">Consultez vos achats récents et les caissiers associés.</p>
      </div>
    </div>
  </div>

  <div class="card-glass p-3 mb-3">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h4 class="mb-0">Historique</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="mb-0" for="monthSelectAchats">Mois</label>
        <select id="monthSelectAchats"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-0">Par défaut seuls les achats du mois courant s’affichent. Choisissez un mois passé
      pour voir ceux déjà chargés.</p>-->
  </div>

  <div class="row g-3">
    <div class="col-sm-6 col-lg-4" *ngFor="let a of achatslist">
      <div class="card card-glass h-100">
        <div class="card-header border-0 text-white text-center font-weight-bolder">
          {{a.date | date:"dd/MM/yyyy H:mm:ss"}}
        </div>
        <div class="card-body">
          <div class="metric-row"><span>Lieu</span><strong>{{a.boutique}}</strong></div>
          <div class="metric-row"><span>Caissier(e)</span><strong>{{a.identification}}</strong></div>
          <div class="metric-row"><span>Montant</span><strong>{{a.montan | currency:a.sigleMonnaie}}</strong></div>
          <div class="metric-row"><span>Solde avant</span><strong>{{a.soldeAvant | currency:a.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row"><span>Solde apres</span><strong>{{a.soldeApres | currency:a.sigleMonnaie}}</strong>
          </div>
        </div>

      </div>
    </div>
    <div class="col-12" *ngIf="!achatslist || achatslist.length === 0">
      <div class="card card-glass p-3 text-center text-muted">Aucun achat enregistré.</div>
    </div>
  </div>
</div>
